<template>
  <div class="dd-selector" :class="selectorClasses">
    <!-- title and selected count,
         use confirmed values as count -->
    <b-arrow-down :title="title" :value="value" @click="onShow" />
    <!-- custom multi-select dropdown dismiss overlay -->
    <div class="dd-selector__bg" @click="onHide" />

    <!-- Only render filters slot on client side
         ref: https://nuxtjs.org/api/components-client-only -->
    <client-only>
      <slot
        :can-render="canRenderSelector"
        :input-value="inputValue"
        :options="options"
        :title="title"
        :on-change="onChange"
        :on-confirm="onConfirm"
        :on-hide="onHide"
        :on-reset="onReset"
      />
    </client-only>
  </div>
</template>

<script>
import ArrowDownButton from '../../button/arrowDownButton'

export default {
  components: {
    'b-arrow-down': ArrowDownButton,
  },
  computed: {
    selectorClasses() {
      return {
        'dd-selector--show': this.showSelector,
      }
    },
  },
  data() {
    return {
      /** Whether the multi-select filters can be rendered */
      canRenderSelector: false,

      inputValue: this.value,

      /** Whether to display the multi-select filters */
      showSelector: false,
    }
  },
  methods: {
    /**
     * Update selected values on filter change
     */
    onChange(newValue) {
      this.inputValue = newValue
    },
    /**
     * Confirm button is clicked
     */
    onConfirm() {
      // Hide the multi-select filters
      this.onHide()
      // Emit selected values to parent
      this.$emit('input', {
        filterQueryKey: this.filterQueryKey,
        value: this.inputValue,
      })
    },
    /**
     * Hide multi-select filters
     */
    onHide() {
      this.showSelector = false
    },
    /**
     * Reset button is clicked
     */
    onReset() {
      // Clear selected value
      this.inputValue = []
      // Emit reset event to parent
      this.$emit('reset', this.filterQueryKey)
    },
    /**
     * Open multi-select filters
     */
    onShow() {
      // Reset the selected values to confirmed value
      this.inputValue = this.value
      // Open the multi-select filters
      this.showSelector = true

      // If multi-select filters not rendered yet,
      // trigger rendering
      if (!this.canRenderSelector) {
        this.canRenderSelector = true
      }
    },
  },
  props: {
    /**
     * filter query key
     */
    filterQueryKey: {
      default: '',
      type: String,
    },
    /**
     * all selection options
     */
    options: {
      default: () => [],
      type: Array,
    },
    /**
     * title
     */
    title: {
      default: '',
      type: String,
    },
    /**
     * value
     */
    value: {
      default: () => [],
      type: Array,
    },
  },
}
</script>

<style lang="postcss" scoped>
.dd-selector {
  @apply relative;

  /* Tooltip hidden background */
  & .dd-selector__bg {
    @apply fixed inset-0 z-10 bg-transparent;
  }
}

@screen mobile {
  .dd-selector {
    /* Invisible background */
    & .dd-selector__bg {
      @apply hidden;
    }
  }
}

@screen desktop {
  /* Hidden desktop filter */
  .dd-selector:not(.dd-selector--show) {
    /* Invisible background */
    & .dd-selector__bg {
      @apply pointer-events-none;
    }
  }
}
</style>
